module.exports = __webpack_public_path__ + "img/trash.afc4157c.svg";